import * as userAction from "../actions/action.user";

const initialState = {
  username: '',
  name: '',
  email: '',
  active: '',
  permissions: []

};

const user = (state = initialState, action = {}) => {
  //alert(action.type);
  const {info} = action;
  //console.log(action.info)
  switch (action.type) {
    case userAction.SET_USER:
      return (
        {
          username: info.username,
          name: info.name,
          email: info.email,
          active: info.active,
          permissions: []
        }
      );
    case userAction.EMPTY_USER:
      return (
        {
          username: '',
          name: '',
          email: '',
          active: '',
          permissions: []
        }
      );
    default:
      return state;
  }
}

export default user;
